import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist} from "../../../Services/BrowserDatabaseFunctions";

export function updateEventTitle(_event_id, _event_name){

    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                event.title = _event_name;

                return dataStore.put(event).then(() => {
                    console.log(
                        `Event title added/updated successfully.`
                    );
                    return true;
                });

            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventTitle:", error);
            throw error;
        });
}

export function addEventCoverImage(_event_id, _cover_image) {
    console.log('addEventCoverImage');

    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Events', 'readwrite');
            const dataStore = tx.objectStore('Events');

            // Fetch the event stored directly by ID
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // Apply update
                event.coverImage = _cover_image;

                // Sanitize to avoid DataCloneError
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Write updated event back
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log('Updated the Event cover image thumbnail');
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred:", error);
            throw error; // rethrow to caller
        });
}

export function addEventCoverImageFullSizeAndThumbnail(_event_id, _file_name, _full_size_image_data, _thumbnail_data) {
    console.log("addEventCoverImageFullSizeAndThumbnail");

    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // Update fields on the event
                event.file_name = _file_name;
                event.cover_image_full_data = _full_size_image_data;
                event.cover_image_thumbnail = _thumbnail_data;

                // Sanitize to avoid DataCloneError if anything odd is on the object
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Put the updated event back into the object store
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log("Updated the Event cover image full size and thumbnail");
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}
export function addEventCoverImageThumbnail(_event_id, _image_data) {
    console.log('addEventCoverImageThumbnail');

    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Events', 'readwrite');
            const dataStore = tx.objectStore('Events');

            // Fetch the event stored directly by ID
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // Apply update
                event.cover_image_thumbnail = _image_data;

                // Sanitize to avoid DataCloneError
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Write updated event back
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log('Updated the Event cover image thumbnail');
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred:", error);
            throw error; // rethrow to caller
        });
}

export function updateEventCoverIntro(_event_id, _event_intro){

    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                event.eventIntro = _event_intro;

                return dataStore.put(event).then(() => {
                    console.log(
                        `Event Intro added/updated successfully.`
                    );
                    return true;
                });

            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventTitle:", error);
            throw error;
        });
}

export function updateEventCategories(_event_id, _attendee_id, _categories) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // 1. Safety check: Ensure menu_items is an array
                if (!Array.isArray(event.menu_items)) {
                    event.menu_items = [];
                }

                // 2. Check if the user already exists in the array
                const existingIndex = event.menu_items.findIndex(item => item.id === _attendee_id);

                if (existingIndex !== -1) {
                    // Update existing user
                    event.menu_items[existingIndex] = {
                        ...event.menu_items[existingIndex],
                        categories: _categories
                    };
                } else {
                    // 3. Optional: Add the user if they weren't in menu_items yet
                    event.menu_items.push({
                        id: _attendee_id,
                        categories: _categories
                    });
                }

                return dataStore.put(event).then(() => {
                    // Minor: Fixed your console log to match the action
                    console.log(`Categories updated for attendee ${_attendee_id} in event ${_event_id}`);
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventCategories:", error);
            throw error;
        });
}

export function updateEventStatus(_event_id, _event_closed, _event_status){

    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                event.closed = _event_closed;
                event.status = _event_status;

                return dataStore.put(event).then(() => {
                    console.log(
                        `Event status added/updated successfully.`
                    );
                    return true;
                });

            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventStatus:", error);
            throw error;
        });
}
